const pages = [
    { 
        'id' : "1",
        'text' : 'chiSiamo',
        'path' : '/about',
    },
    { 
        'id' : "2",
        'text' : 'camere',
        'path' : '/rooms'
    },
    // { 
    //     'id' : "3",
    //     'text' : 'servizi',
    //     'path' : '/services'
    // },
    { 
        'id' : "4",
        'text' : 'piscina',
        'path' : '/pool'
    },
    { 
        'id' : "5",
        'text' : 'doveSiamo',
        'path' : '/where'
    },
  ];

  export default pages;